module.exports = __webpack_public_path__ + "static/media/raven_funny_05.02bd3abe.svg";